<template>
  <v-dialog v-model="dialogValue" v-bind="$attrs" :fullscreen="fullscreenState" :max-width="fullscreenState ? undefined : maxWidth">

    <template v-if="$slots.activator" #activator="slotProps">
      <slot name="activator" v-bind="slotProps" />
    </template>

    <div :class="isDark ? 'bg-blue-300/80' : 'bg-blue-300/50'" class="text-h5 pl-2 text-black" style="position: sticky; top: 0; z-index: 100; border-radius: 5px 5px 0 0;">
      <v-row align="center" style="position: relative; height: 72px;">
        <v-col cols="9" style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          <slot name="title" />
        </v-col>
        <v-col cols="12" style="width: 100%; position: absolute; right: 0; top: 0;">
          <v-btn-group class="float-right">
            <v-btn size="small" variant="tonal" icon="mdi-theme-light-dark" @click="toggleTheme" title="Toggle Theme" />
            <v-btn size="small" variant="tonal" color="" :icon="fullscreenIcon" @click="toggleFullscreen" title="Toggle Fullscreen" />
            <v-btn size="small" variant="tonal" icon="mdi-close" color="error" @click="dialogValue = false" title="Close" />
          </v-btn-group>
        </v-col>
      </v-row>
    </div>
    <v-card>
      <v-card-text :class="cardTextClass">
        <slot />
      </v-card-text>

      <v-card-actions :class="isDark ? 'bg-blue-300/10' : 'bg-blue-300/50'" class="px-1 py-0">
        <v-spacer />
        <v-btn color="blue-darken-1" variant="outlined" size="small" rounded="xl" @click="dialogValue = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue'
import { useVuetify } from '@/Composables/useVuetify.js'

const { toggleTheme, isDark } = useVuetify()

// Props & Emits
const props = defineProps({
  modelValue: { type: Boolean, default: undefined },
  fullscreen: { type: Boolean, default: false },
  maxWidth: [String, Number],
  cardTextClass: String,
})
const emit = defineEmits(['update:modelValue'])

const internal = ref(false)

const isControlled = computed(() => props.modelValue !== undefined)

const dialogValue = computed({
  get: () => isControlled.value ? props.modelValue : internal.value,
  set: val => {
    if (isControlled.value) {
      emit('update:modelValue', val)
    } else {
      internal.value = val
    }
  }
})

const internalFullscreen = ref(false)
const fullscreenState = computed({
  get: () => props.fullscreen || internalFullscreen.value,
  set: val => internalFullscreen.value = val
})

const fullscreenIcon = computed(() => {
  return fullscreenState.value ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'
})

function toggleFullscreen() {
  fullscreenState.value = !fullscreenState.value
}

</script>

<script>
export default {
  inheritAttrs: false
}
</script>

<style>
.v-dialog--fullscreen>.v-overlay__content>.v-card {
  min-height: calc(100% - 48px) !important;
}
.v-dialog--fullscreen>.v-overlay__content {
  overflow-y: unset !important;
}
</style>
